export const fontSize = {
  base: "1rem",
  lg: "1.333rem",
  xl: "2.666rem",
};

export const spacing = {
  none: 0,
  xs: "4px",
  sm: "8px",
  base: "16px",
  lg: "24px",
  xl: "32px",
  "2xl": "40px",
  "3xl": "48px",
};

export const shadowSpacing = {
  base: ["0.042rem", "0.055rem", "0.083rem", "0.166rem"] /* base18: ['0.75px', '1px', '1.5px', '3px'] */,
  lg: ["0.055rem", "0.111rem", "0.166rem", "0.222rem"] /* base18: ['1px', '2px', '3px', '4px'] */,
  xl: ["0.111rem", "0.222rem", "0.333rem", "0.444rem"] /* base18: ['2px', '4px', '6px', '8px'] */,
};
